export const INLINE_MATH_PATTERN = String.raw`\$([^$\n]+)\$`;
export const BLOCK_MATH_PATTERN = String.raw`\$\$([^$]+)\$\$`;
